module.exports = __webpack_public_path__ + "media/images/flags/bw-131024ae018e4435ae26079ce8b7038b.svg";